<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    parentStoreName="Providers"
    :submit="submit"
    :status="status"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row justify="center">
        <v-col cols="6">
          <v-row>
            <v-col>
              <ValidationProvider
                ref="full_name"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.full_name"
                  label="Nombre y Apellido"
                  prepend-inner-icon="fas fa-user"
                  ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
             <v-col>
              <ValidationProvider
                ref="email"
                rules="required|email"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.email"
                  label="E-mail"
                  prepend-inner-icon="fas fa-envelope"
                ></v-text-field>
              </ValidationProvider>
            </v-col>

            <v-col>
              <ValidationProvider
                ref="password"
                rules="min:4"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.password"
                  label="Password"
                  :type="show1 ? 'text' : 'password'"
                  :append-icon="show1 ? 'fas fa-eye' : 'fas fa-eye-slash'"
                  @click:append="show1 = !show1"
                  autocomplete="off"
                  readonly
                  onfocus="this.removeAttribute('readonly');"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <ValidationProvider
                      ref="profile_picture" rules=""
                      v-slot="{ errors }"
              >
                <Upload
                        :error-messages="errors"
                        accept="image/png, image/jpeg, image/jpg"
                        placeholder="Imagen de Perfil"
                        prepend-icon="fas fa-camera"
                        label=""
                        :multiple="false"
                        :onSelectedPicture="onSelectedPicture"
                ></Upload>
                <v-img
                        :src="profile_picture"
                        width="200"
                        style="margin: auto"
                ></v-img>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapState } from "vuex";
import Upload from "@/components/Upload";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";

export default {
  mixins: [CrudFormMixin],
  components: { CrudForm, ValidationProvider, Upload, ValidationObserver },

  data() {
    return {
      storeName: "Providers",
      title: "Proveedor",
      filteredAttributes: ["profile_picture"],
      show1: false,
      profile_picture: "",
      data: {
        full_name:"",
        email: "",
        password: "",
        profile_picture: undefined,
      },
    };
  },
  computed: {
    ...mapState({
      status: (state) => state.Providers.status
    }),
  },
  watch: {

  },
  methods: {
      onSelectedPicture(file) {
          const self = this;
          this.data.profile_picture = file;

          let fr = new FileReader();
          fr.onload = function () {
              self.profile_picture = fr.result;
          };
          fr.onerror = function () {
              self.profile_picture = '';
          };
          fr.readAsDataURL(this.data.profile_picture);
      }
  },
};
</script>
